import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";

import CheckCircleIcon from '@mui/icons-material/CheckCircle';



import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import {
  TENANT_CLIENT_LIST_QUERY,
  DELETE_CLIENT_MUTATION,
} from "../../graphQL/client_qry";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import SelectDefaultClientDialog from "../../components/SelectDefaultClientDialog.js";
import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  largeButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#4080ad",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function ClientList() {
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);

  const [tenantClientList, setTenantClientList] = useState([]);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 1;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [defaultClientDialog, setDefaultClientDialog] = useState(false);
  const [selectedDefaultClient, setSelectedDefaultClient] = useState(null);

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Clients",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [fetchTenantClientList] = useManualQuery(TENANT_CLIENT_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const [deleteClientMutation] = useMutation(DELETE_CLIENT_MUTATION, {
    fetchPolicy: "network-only",
  });

  const getClientsList = async () => {
    const {
      loading: clientsListLoading,
      error: clientsListError,
      data: clientsListData,
    } = await fetchTenantClientList();

    if (!clientsListLoading && clientsListData && clientsListData.tenantClientList) {
      setTenantClientList(clientsListData.tenantClientList);
      for (var i in clientsListData.tenantClientList) {
        let defClient = clientsListData.tenantClientList[i];        
        if (defClient.defaultClient) setSelectedDefaultClient(defClient.clientId);
        
      }
      setLoadData(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getClientsList())();
  }, []);

  function checkDeleteStatus(row) {
    if (row.deleteMessage !== "")
      setAlertDeleteMsg({
        title: "Delete Client",
        msg: row.deleteMessage,
      });
    else
      setAlertDeleteMsg({
        title: "Delete Client",
        type: "deleteConfirmation",
        msg: 'Are you sure you want to delete the client "' + row.name + '"?',
        clientUuid: row.clientUuid,
      });
  }

  const deleteClient = async clientUuid => {
    const {
      loading: loadingClientDelete,
      error: errorClientDelete,
      data: dataClientDelete,
    } = await deleteClientMutation({
      variables: {
        clientUuid: clientUuid,
      },
    });
    if (!loadingClientDelete && dataClientDelete && dataClientDelete.deleteClient) {
      getClientsList();
    }
    if (errorClientDelete) {
      if (errorClientDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else alert(errorClientDelete.graphQLErrors[0].message);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 170,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    renderCell: rows => {
        return rows.row.defaultClient ? (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Default Client">
            
              <CheckCircleIcon
                    color="action"
                    style={{ marginRight: 10, cursor: "pointer", marginTop: 15 }}
                    
                  />
              
            </StyledTooltip>
            
              <Typography variant="h3" style={{ fontSize: 14, marginTop: 15 }}>
                {rows.row.name}
              </Typography>
            
          </Box>
        ) : (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {rows.row.name}
          </Box>
        );
      },
    },
    {
      field: "dateCreated",
      headerName: "Date Created",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "dateUpdated",
      headerName: "Date Updated",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "termNoOfWeeks",
      headerName: "Term No of Weeks",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "termStartDate",
      headerName: "Term Start Date",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
             <StyledTooltip title="Edit this client" >
                  <img
                    style={{
                      paddingRight: 15,
                      cursor: editCursor,
                      paddingTop: 6,
                      height: 24,
                      weight: 24,
                      filter: editFilter,
                      opacity: editOpacity,
                    }}
                    src={penImg }
                    onClick={() => rows.row.editAccess ? navigate(`${project_url}/clients/` + rows.row.clientUuid) : ""}
                />
             </StyledTooltip>
             
             <StyledTooltip title="Delete this client">
                  <img
                    style={{
                      paddingRight: 15,
                      cursor: deleteCursor,
                      paddingTop: 6,
                      height: 24,
                      weight: 24,
                      filter: deleteFilter,
                      opacity: deleteOpacity,
                    }}
                    src={trashImg}
                    onClick={() => rows.row.deleteAccess ? checkDeleteStatus(rows.row): ""}
                  />
                </StyledTooltip>
              
          </Box>
        );
      },
    },
  ];

  var rows = tenantClientList.map(client => ({
    id: client.clientId,
    clientUuid: client.clientUuid,
    name: client.name,
    defaultClient : client.defaultClient,
    dateCreated: dayFormat(client.createDate),
    dateUpdated: dayFormat(client.updateDate),
    termNoOfWeeks: client.termNoOfWeeks,
    termStartDate: dayFormat(client.termStartDate),
    deleteMessage: client.deleteMessage,
    editAccess : editAccess,
    deleteAccess: deleteAccess,
  }));
  
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={9} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Clients
            </Typography>
          </Grid>

          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.largeButtonStyle}
              disabled = {!editAccess ? "disabled" : ""}
              onClick={() => editAccess ? setDefaultClientDialog(true) : ""}
            >
              Set Default Client
            </Button>
          </Grid>

          <Grid
            item
            xs={1}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
           
           <Button variant="contained" size="small" className={classes.buttonStyle}  disabled = {!addAccess ? "disabled" : ""}
                onClick={() => addAccess ? navigate(`${project_url}/clients/add`) : ""}>
                Add
              </Button>
           
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  if (access)
  if (loadContent && loadData)
    if (access)
    return (
      <div className={classes.root}>
        <Header />        
        <div className={classes.container}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              sorting: {
                sortModel: [{ field: "name", sort: "asc" }],
              },
            }}
            getRowClassName={params => (params.row.defaultClient ? "default-row" : "")}
          />
          <style>
            {`
              .default-row {
                background-color: rgba(203, 255, 139, 0.33) !important; /* Light green */
              }
            `}
          </style>

          {defaultClientDialog && (
            <SelectDefaultClientDialog
              closeDialog={() => {
                setDefaultClientDialog(false);
                getClientsList();
              }}
              clientsList={rows}
              selectedDefaultClient={selectedDefaultClient}
            />
          )}

          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteClient(alertDeleteMsg.clientUuid);
              }}
            />
          )}
        </div>
      </div>
    );
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );  
  else return;
  
}

export default ClientList;
